<div class="h5-top-menu" cdkOverlayOrigin #containerOrigin="cdkOverlayOrigin">
  @if (!['register', 'login', 'password'].includes(currentPage)) {
    <div class="imchat" *ngIf="logined && chatService.chatEnabled" (click)="chatService.toggleChat(true)">
      <i class="im-chat-icon"></i>
      <em class="avatar-badge" *ngIf="chatService.unreadCount > 0">
        {{ chatService.unreadCount > 99 ? '99+' : chatService.unreadCount }}
      </em>
    </div>
    @if (logined) {
      <div class="user-avatar" (click)="popStatus.user = !popStatus.user">
        <app-user-avatar
          [isActive]="popStatus.user"
          [bounsCount]="bounsCount"
          [avatarImgSrc]="userInfo?.avater || ''"
          [currentVipLevel]="currentVipLevel"
          [isSuperVip]="isSuperVip"
          [messagesCount]="messagesCount"
        />
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="containerOrigin"
          [cdkConnectedOverlayOpen]="popStatus.user"
          [cdkConnectedOverlayPositions]="containerPositions"
          [cdkConnectedOverlayFlexibleDimensions]="true"
          (overlayOutsideClick)="popStatus.user = false"
        >
          <div class="user-center-contaienr" (click)="popStatus.user = !popStatus.user">
            <app-scrollbar>
              @for (item of menuData[0]; track $index) {
                <cs-standard-tab
                  [class]="item.class || ''"
                  *ngIf="(!item.showOnly || item.showOnly === 'web') && !item.showOnlyCountry"
                  (click)="menuClick(item, $event)"
                  [routerLink]="!item.page ? null : item.page"
                  [routerLinkActive]="!item.page ? '' : 'active'"
                >
                  <div>
                    <i class="fi-{{ item.icon }}"></i>
                    <span>{{ item.title | translate }}</span>
                  </div>
                  @if (item.ident === 'bonuses') {
                    <em *ngIf="bounsCount">{{ bounsCount > 99 ? '99+' : bounsCount }}</em>
                  }
                  @if (item.ident === 'notifications') {
                    <em *ngIf="messagesCount">{{ messagesCount > 99 ? '99+' : messagesCount }}</em>
                  }
                </cs-standard-tab>
              }
            </app-scrollbar>
          </div>
        </ng-template>
      </div>
    } @else {
      <cs-button
        [label]="'log_in' | translate"
        [height]="'32px'"
        [color]="'third'"
        size="small"
        (buttonClick)="appService.jumpToLogin()"
      ></cs-button>
      <cs-button
        [label]="'sign_up' | translate"
        [height]="'32px'"
        [color]="'primary'"
        size="small"
        (buttonClick)="appService.jumpToRegister()"
      ></cs-button>
    }
  }
</div>

<ng-template #commonHead>
  <div class="popup-head">
    <i class="mutual-opacity icon-arrow-left onact96-not" style="margin-right: auto" (click)="close()"></i>
    <!-- <app-theme-switch #themeSwitch [simple]="true"></app-theme-switch> -->
    <!-- <i class="mutual-opacity icon-kefu"></i> -->
  </div>
</ng-template>

<ng-template #menuPopup>
  <div class="popup-full top-menu-popup" *ngIf="useFor === 'h5-topMenu'; else langSelect">
    <ng-container *ngTemplateOutlet="commonHead"></ng-container>
    <div class="popup-body">
      <!-- 未登入 -->
      <div class="not-logged" *ngIf="!logined">
        <app-logo [onlineSizeH5]="['auto', '36']" [sitSizeH5]="['38', '36']" />
        <!-- 首页 Banner 轮播 -->
        <app-normal-carousel class="carousel" [buildFor]="'FrontPage'" />
        <div class="sponsor">
          <div class="sponsor-overview row">
            <div class="row" *ngFor="let item of sponsors">
              <img class="sponsor-img" [src]="getImageThemeUrl(item.image | translate, item.imageTheme)" />
              <div class="col">
                <div class="sponsor-name">{{ item.name | translate }}</div>
                <div class="sponsor-season">{{ item.season | translate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="feature">
          <div class="feature-title row">
            <div class="col" *ngFor="let item of features">{{ item.title | translate }}</div>
          </div>
          <div class="feature-subtitle row">
            <div class="col" *ngFor="let item of features">{{ item.subtitle | translate }}</div>
          </div>
        </div>
        <div class="btns">
          <cs-button
            [label]="'login_button' | translate"
            [color]="'third'"
            size="small"
            (buttonClick)="appService.jumpToLogin()"
          ></cs-button>
          <cs-button
            [label]="'register_button' | translate"
            [color]="'primary'"
            size="small"
            (buttonClick)="appService.jumpToRegister()"
          ></cs-button>
          <div class="customer-service onact96">
            <span (click)="goService()">
              {{ 'online_cs' | translate }}
            </span>
          </div>
        </div>
      </div>

      <!-- 已登入 -->
      <div class="user-Info" *ngIf="logined">
        <div class="user-name">{{ userName }}</div>
        <div>
          <span class="vip-img onact96-not" [routerLink]="'loyalty'" (click)="close()"></span>
          <span class="vip-text onact96" [routerLink]="'loyalty'" (click)="close()">
            <ng-container *ngIf="!vipLoading">
              {{ (isSuperVip ? 'customize_vip10' : 'customize_vip' + currentVipLevel) | translate }}
            </ng-container>
            <i class="animation-icon-loading-dot" *ngIf="vipLoading"><i></i><i></i><i></i></i>
          </span>
          <div class="kyc-status onact96-not" [class.active]="kycLevel > 1" (click)="jumpToKyc()">
            <ng-container *ngIf="!kycStatusLoading">
              {{ kycStatusName }}
            </ng-container>
            <i class="animation-icon-loading-dot" *ngIf="kycStatusLoading"><i></i><i></i><i></i></i>
          </div>
        </div>
      </div>
      <div class="menus">
        <ng-container *ngFor="let group of menuData">
          <div class="menu-group" *ngIf="checkGroup(group)">
            <ng-container *ngFor="let item of group">
              <div class="menu-item" *ngIf="checkItem(item)">
                <div
                  class="menu onact96"
                  [routerLink]="getRouterLink(item)"
                  [routerLinkActive]="getRouterLinkActive(item)"
                  (click)="menuClick(item, $event)"
                >
                  <span class="menu-icon icon-{{ item.icon }}"></span>
                  <span>{{ item.title | translate }}</span>
                  <span
                    class="icon-arrow-left-simple expand-icon"
                    *ngIf="item.children && checkGroup(item.children)"
                  ></span>
                  @switch (item.icon) {
                    @case ('bell') {
                      <ng-container *ngTemplateOutlet="badge; context: { num: messagesCount }"></ng-container>
                    }
                    @case ('coupon') {
                      <ng-container *ngTemplateOutlet="badge; context: { num: bounsCount }"></ng-container>
                    }
                    @case ('chat-vip') {
                      <ng-container *ngTemplateOutlet="badge; context: { num: chatService.unreadCount }"></ng-container>
                    }
                  }
                </div>
                <div class="sub-menus" *ngIf="item.children && checkGroup(item.children)">
                  <ng-container *ngFor="let subItem of item.children">
                    <div
                      class="menu sub-menu onact96"
                      *ngIf="checkItem(subItem)"
                      [routerLink]="getRouterLink(subItem)"
                      [routerLinkActive]="getRouterLinkActive(subItem)"
                      (click)="$event.stopPropagation(); menuClick(subItem, $event)"
                    >
                      <span>{{ subItem.title | translate }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <ng-template #langSelect>
    <div class="popup-full langSelect-popup">
      <ng-container *ngTemplateOutlet="commonHead"></ng-container>
      <div class="title">
        <div>{{ 'lang_and_region' | translate }}</div>
      </div>
      <div class="popup-body">
        <div class="lang-item desc">{{ 's_lang_and_region' | translate }}</div>
        <ng-container *ngFor="let item of allLangData">
          <div class="lang-item onact96" [class.select]="item.code === langCode" (click)="selectLang(item)">
            <i class="country lang-img" [class]="countryClassName(item.code)"></i>
            <span>{{ item.name }}</span>
            <span class="icon icon-correct"> </span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #badge let-num="num">
  <em class="badge" *ngIf="num > 0">{{ num > 99 ? '99+' : num }}</em>
</ng-template>
